export enum FinancialConnectionGocardlessAccessScopes {
    Balances = 'balances',
    Details = 'details',
    Transactions = 'transactions',
}
